<script setup>
import AppLoading from '@/components/common/AppLoading.vue'
import { useAppStore } from '@/stores/app'
import { useUserStore } from '@/stores/user'

const appStore = useAppStore()
const userStore = useUserStore()

// 计算加载状态
const isLoading = computed(() => !userStore.initialized)

onMounted(async () => {
  // 初始化应用配置
  appStore.initAppConfig()

  // 初始化用户store
  await userStore.init()
})

onUnmounted(() => {
  // 清理用户store
  userStore.cleanup()
})
</script>

<template>
  <div id="app">
    <AppLoading v-model:visible="isLoading" />
    <router-view v-if="userStore.initialized" />
  </div>
</template>

<style>
#app {
  min-height: 100vh;
}
</style>
